import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ImportExternalAccountsResultDialogComponent } from '@irb/irb-clients/import-external-accounts-result-dialog/import-external-accounts-result-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ImportExternalAccountsResultGridLayoutService implements GridLayoutService<ImportExternalAccountsResultDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs(): Array<any> {
        return [{
            headerName: 'Account',            
            field: 'accountNumber',
            maxWidth: 100,
            width: 100,
            sort:'asc'
        },
        {
            headerName: 'Error Condition',
            field: 'errorDesc',
            flex: 1
        }];
    }

    getColumnDefsWithSelectAll(parent: ImportExternalAccountsResultDialogComponent): Array<any> {
        const c = [{
                headerName: 'Select All',
                headerComponent: 'customHeader',
                cellRenderer : 'customHeader',
                cellRendererParams: {parentObject: parent, type: 'rowCheckBox' },
                suppressColumnsToolPanel: true,
                suppressSizeToFit: true,
                toolPanelClass: 'toolpanel-header-checkbox-hide',
                headerComponentParams: {parentObject: parent, type: 'headerCheckBox', cbSelectAllInpChecked:true},
                suppressMovable: true,
                lockPosition: true,
                lockVisible: true,
                sortable: false,
                filter: true,
                resizable: false,
                minWidth: 25,
                width: 25,
                maxWidth:25,
                cellStyle: {'padding' : '5px 3px 0 2px'},
                headerClass: 'customHeaderClassSelectAll',
                cellClass: 'selectAllCheckBoxRecord'
            }];
        
        return c.concat(this.getColumnDefs());
    }
}
